import React, { useEffect } from "react";

export default function VitalsForm({ vitals, onChange }) {
  const set = (k, v) => onChange({ ...vitals, [k]: v });

  // Auto BMI if weight/height change
  useEffect(() => {
    if (vitals.height > 0 && vitals.weight > 0) {
      const bmi = Math.round(((vitals.weight / (vitals.height * vitals.height)) * 703) * 10) / 10;
      if (bmi !== vitals.bmi) onChange({ ...vitals, bmi });
    }
    // eslint-disable-next-line
  }, [vitals.weight, vitals.height]);

  return (
    <div className="cn-card">
      <h3>Vitals</h3>
      <div className="row">
        <div><label>Weight (lbs)</label><input type="number" value={vitals.weight} onChange={(e)=>set("weight", Number(e.target.value))} /></div>
        <div><label>Height (in)</label><input type="number" value={vitals.height} onChange={(e)=>set("height", Number(e.target.value))} /></div>
        <div><label>BMI</label><input type="number" value={vitals.bmi} readOnly /></div>
        <div><label>Temperature</label><input type="number" value={vitals.temperature} onChange={(e)=>set("temperature", Number(e.target.value))} /></div>
        <div><label>Pulse</label><input type="number" value={vitals.pulse} onChange={(e)=>set("pulse", Number(e.target.value))} /></div>
        <div><label>O2 Sat (%) / Room Air</label><input type="number" value={vitals.o2SatRa} onChange={(e)=>set("o2SatRa", Number(e.target.value))} /></div>
      </div>
      <div className="row">
        <div><label>Previous BP (Sys)</label><input type="number" value={vitals.bpPrevSys} onChange={(e)=>set("bpPrevSys", Number(e.target.value))}/></div>
        <div><label>Previous BP (Dia)</label><input type="number" value={vitals.bpPrevDia} onChange={(e)=>set("bpPrevDia", Number(e.target.value))}/></div>
        <div><label>BP #1 (Sys)</label><input type="number" value={vitals.bp1Sys} onChange={(e)=>set("bp1Sys", Number(e.target.value))}/></div>
        <div><label>BP #1 (Dia)</label><input type="number" value={vitals.bp1Dia} onChange={(e)=>set("bp1Dia", Number(e.target.value))}/></div>
        <div><label>BP Position (Option1)</label>
          <select value={vitals.bpOption1} onChange={(e)=>set("bpOption1", Number(e.target.value))}>
            <option value={1}>Sitting</option>
            <option value={2}>Standing</option>
            <option value={3}>Supine</option>
          </select>
        </div>
        <div><label>BP Arm (Location1)</label>
          <select value={vitals.bpLocation1} onChange={(e)=>set("bpLocation1", Number(e.target.value))}>
            <option value={1}>Left</option>
            <option value={2}>Right</option>
          </select>
        </div>
      </div>
    </div>
  );
}
